import { render, staticRenderFns } from "./AssignAutomaticSoundPopup.vue?vue&type=template&id=308ddf58&scoped=true"
import script from "./AssignAutomaticSoundPopup.vue?vue&type=script&lang=ts"
export * from "./AssignAutomaticSoundPopup.vue?vue&type=script&lang=ts"
import style0 from "./AssignAutomaticSoundPopup.vue?vue&type=style&index=0&id=308ddf58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308ddf58",
  null
  
)

export default component.exports